<template>
  <page-listado>
    <page-header title="Histórico Versiones" @back="volver">
      <b-button variant="primary" size="sm" to="/ofertas/crear">
        <v-icon name="plus" width="16" />
        Crear oferta
      </b-button>
      <busqueda-rapida />
    </page-header>

    <tabla-ofertas :ofertas="resultado.ofertas">
      <template v-slot:botonera="{ oferta }">
        <botonera-version :oferta="oferta" @ofertaCambiada="listar" />
      </template>
    </tabla-ofertas>

    <paginacion :page-count="parseInt(resultado.numeroPaginas)" :page="parseInt(resultado.pagina)" />
  </page-listado>
</template>

<script>
import * as ofertasApi from "@/services/ofertas";
import TablaOfertas from "./Listar/TablaOfertas.vue";
import BotoneraVersion from "./Listar/BotoneraVersion.vue";

export default {
  components: { TablaOfertas, BotoneraVersion },
  data() {
    return {
      resultado: {
        ofertas: [],
        numeroPaginas: 0,
        pagina: 1,
      },
      reloadListar: false,
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    volver() {
      this.$router.push("/ofertas");
    },
    listar() {
      return ofertasApi.listarVersionesDe(this.$route.params.id, this.$route.query).then((resultado) => {
        this.resultado = resultado;
      });
    },
    mensaje(mensaje) {
      this.$messages.success(mensaje);
      this.listar();
      //this.reloadListar = true;
    },
  },
};
</script>
